wbApp.controller('OnlinePaymentConfigurationCtrl', ['$scope', '$modal', '$q', '$translate', 'onlinePaymentConfigurationSvc',
function ($scope, $modal, $q, $translate, onlinePaymentConfigurationSvc) {

    $scope.onlinePaymentConfigurations = onlinePaymentConfigurationSvc.getAllAsync(true);

    $scope.gridSettings = {
        columns: [
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', sortOrder: 'asc' },
            {
                dataField: 'providerType',
                caption: $translate.instant('TXT_LBL_PROVIDER_TYPE'),
                dataType: 'number',
                width: '140px',
                lookup: {
                    dataSource: {
                        store: {
                            type: 'array',
                            data: [
                               // { id: 0, name: 'Payeezy (Fio)' },
                                { id: 1, name: 'Comgate' },
                                { id: 2, name: 'GP webpay' }
                            ],
                            key: "id"
                        }
                    },
                    valueExpr: 'id', 
                    displayExpr: 'name'
                }
            },
            { dataField: 'isTestConfig', caption: $translate.instant('TXT_LBL_IS_TESTING'), dataType: 'boolean', width: '80px' },
        ]
    }

    $scope.$on('refreshData', function (e, data) {
        $scope.onlinePaymentConfigurations = onlinePaymentConfigurationSvc.getAllAsync(true);
    });

    $scope.onRowEdit = function (data) {
        $q.all([detailDialogPromise.$promise,
            onlinePaymentConfigurationSvc.getAsync(data.id).$promise]).then(function (d) {
                detailDialogPromise.$scope.model = angular.copy(d[1]);
                detailDialogPromise.$scope.onSave = function () {
                    $scope.onlinePaymentConfigurations = onlinePaymentConfigurationSvc.getAllAsync(true);
                }
                detailDialogPromise.show();
            });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = onlinePaymentConfigurationSvc.createNew();
            detailDialogPromise.$scope.onSave = function () {
                $scope.onlinePaymentConfigurations = onlinePaymentConfigurationSvc.getAllAsync(true);
            }
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        onlinePaymentConfigurationSvc.remove(data.id).$promise.then(function () {
            $scope.onlinePaymentConfigurations = onlinePaymentConfigurationSvc.getAllAsync(true);
        });
    }

    var detailDialogPromise = $modal({
        templateUrl: 'finance/online-payment-configurations/online-payment-configurations-detail.html',
        show: false,
        scope: $scope.$new()
    });
}]);
